export enum TaskType {
  Registration = 'registration',
  Order = 'order',
  CallbackRequest = 'callback_request',
  CancellationRequest = 'cancellation_request',
  Claim = 'claim',
  MasterDataChange = 'masterdata_change',
}
